<div class="row tw:flex tw:flex-row tw:overflow-x-auto">
  @for (item of items(); track item.name) {
    <app-snap-link [item]="item"></app-snap-link>
  }
</div>